import React, { useState } from 'react'
import ComingSoon from 'react-coming-soon'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import people from '../images/people.jpg'
import '../scss/custom.scss'
import { db } from '../config/firebase'
import Spinner from 'react-bootstrap/Spinner'
import { BsCheck } from 'react-icons/bs'
// media query
import { useMediaQuery } from 'react-responsive'
// react router
import { 
  BrowserRouter as Router, 
  Route, 
  Switch 
} from 'react-router-dom'

function Landing() {
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const smallScreen = useMediaQuery({ query: '(max-width: 520px)' })
  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)
    setSuccess(false)
    db.collection('emails').add({
      email
    })
    .then(() => {
      setEmail("")
      setSuccess(true)
    })
    .catch(e => {console.log('Error: ', e.message)})
    .finally(() => {setLoading(false)})
  }

  return (
    <div>
      <ComingSoon 
        className='landing'
        title="PangoBooks is Coming Soon" 
        date="Sat May 15 2021 12:00:00 GMT-0600 (Mountain Daylight Time)"
        bgColor="##FFFF"
        textColor="#500000"
        subtitle="Buy books, Sell books, PangoBooks"
        image={people}
      >
        <div className={`${smallScreen ? 'small-screen' : 'email-form'}`}>
          <p style={{marginBottom: 10, maxWidth: 350}}>Find out more about PangoBooks and be notified when we launch!</p>
          <Form onSubmit={handleSubmit}>
            <div className={`${smallScreen ? 'col' : 'row'}`}>
              <div className={`${smallScreen ? 'row justify-content-center' : 'col'}`}>
                 <Form.Group controlId="exampleForm.ControlInput1">
                  <Form.Control 
                    onChange={(e) => {setEmail(e.target.value)}} 
                    className='input' 
                    type="email" 
                    placeholder="Email..." 
                    required
                    value={email}
                  />
                </Form.Group>
              </div>
              <div className={`${smallScreen ? 'row justify-content-center' : 'col'}`}>
                <Button 
                  className='button'
                  type='submit'
                >
                  {loading ? 
                    <Spinner 
                      animation="border" 
                      variant="secondary" 
                      size='sm'
                    />
                  :
                    'Submit'
                  }
                </Button>
              </div>
            </div>
          </Form>
          <div>
            {success ? 
              <p style={{width: 350}}><BsCheck /> Cheers! We sent you a brief email with more information about PangoBooks. If you don't see it, check your spam folder. Thanks for dropping by!</p>
            :
              null  
            }
          </div>
        </div>
      </ComingSoon>
    </div>
  );
}

export default Landing;
